import { useState } from 'react'
import type { AdminSectionProps } from './types'
import { CloudReceiptsSection } from './CloudReceiptsSection'
import { SyncQueueSection } from './SyncQueueSection'
import { ContainersMonitorSection } from './ContainersMonitorSection'
import { WriteoffsSection } from './WriteoffsSection'
import { ShiftsMonitorSection } from './ShiftsMonitorSection'
import { AdminCard } from './AdminCard'
import { useAuthToken } from './useAuthToken'
import { btn, btnBase, btnSize, cx } from '@ui/classes'

/** Раздел «Продажи»: чеки в облаке, смены/Z-отчёты и вскрытые упаковки. */
export function SalesSection({ perms }: AdminSectionProps) {
  const token = useAuthToken()
  // Одна кнопка «Обновить» на весь раздел: секции перезагружаются по refreshKey.
  const [refreshKey, setRefreshKey] = useState(0)

  return (
    <>
      <div className="mb-3 flex items-center justify-between gap-2">
        <span className="text-small text-muted">Чеки, смены и упаковки</span>
        <button
          className={cx(btnBase, btn.secondary, btnSize.sm)}
          onClick={() => setRefreshKey((k) => k + 1)}
        >
          ⟳ Обновить
        </button>
      </div>

      <AdminCard id="sales.receipts" title="Чеки в облаке" defaultOpen>
        <CloudReceiptsSection
          refreshKey={refreshKey}
          canApproveMarkingHold={perms.canApproveMarkingHold}
          canWriteoff={perms.canWriteoff}
        />
      </AdminCard>

      <AdminCard id="sales.shifts" title="Смены и Z-отчёты">
        <ShiftsMonitorSection token={token} refreshKey={refreshKey} />
      </AdminCard>

      <AdminCard id="sales.sync-queue" title="Очередь синхронизации">
        <SyncQueueSection refreshKey={refreshKey} />
      </AdminCard>

      <AdminCard id="sales.writeoffs" title="Списания">
        <WriteoffsSection refreshKey={refreshKey} />
      </AdminCard>

      <AdminCard id="sales.containers" title="Вскрытые упаковки">
        <ContainersMonitorSection token={token} refreshKey={refreshKey} />
      </AdminCard>
    </>
  )
}
